import { boot } from 'quasar/wrappers'
import type { PluginOptions } from 'vue-gtag'
import VueGtag from 'vue-gtag'

export default boot(async ({ Vue, router }) => {
  Vue.use(VueGtag, {
    config: { id: 'G-5E0K4L3L06' },
    appName: 'Mentore',
    pageTrackerScreenviewEnabled: true,
  } as PluginOptions, router)
})
